export enum EsnSubscriptionBillingFrequency {
  Yearly = "yearly",
  Monthly = "monthly",
}
